module.exports = __webpack_public_path__ + "static/img/11.5723ae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/11.png
// module id = uAnX
// module chunks = 0